//
// 开关
// ============================================================
import Ns from "./utility";

const Switch = () => new Ns({
    el: ".switch-wrapper",
    eventHandle: {
        type: "click",
        entrust: ".switch-group",
        callback:  function (ev) {
            if (ns(this).hasClass("disabled")) {
                ns(this).attr("title", "禁止选择");
                return;
            }

            if(ns(this).attr("data-switch-toggle") == "false") {
                ns(this).attr("data-switch-toggle", "true").find(".iconfont").removeClass("icon-toggle-off").addClass("icon-toggle-on");
            }else {
                ns(this).attr("data-switch-toggle", "false").find(".iconfont").removeClass("icon-toggle-on").addClass("icon-toggle-off");
            }

            return true;
        }
    },
    load() {
        Ns.each(ns(this).find(".switch-group").get(), item => {
            if ( ns(item).attr("data-switch-toggle") == "true") {
                ns(item).find(".iconfont").addClass("icon-toggle-on").removeClass("icon-toggle-off");
            }
            if (ns(item).hasClass("disabled")) {
                ns(item).attr("title", "禁止选择")
            }
        })
    },
});

module.exports = Switch;


// WEBPACK FOOTER //
// src/js/switch.js